import React from "react";
import PageView from "@/pages";
import { HashRouter } from "react-router-dom";
import { DataVersionGate, TrendDataProvider } from "@/providers";

const App: React.FC = () => {
  return (
    <React.Suspense fallback={<div className="page-loading">加载中...</div>}>
      <DataVersionGate>
        {context => (
          <TrendDataProvider {...context}>
            <HashRouter>
              <PageView />
            </HashRouter>
          </TrendDataProvider>
        )}
      </DataVersionGate>
    </React.Suspense>
  );
};

export default App;
